"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCarouselHeader = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CarouselHeaderMixin = require("../../mixins/components/CarouselHeaderMixin");
var StyledCarouselHeader = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledCarouselHeader",
  componentId: "c11n-8-107-0__sc-cjyas6-0"
})(["", ""], _CarouselHeaderMixin.CarouselHeaderMixin);
exports.StyledCarouselHeader = StyledCarouselHeader;